import { render, staticRenderFns } from "./DriverTicketDetail.vue?vue&type=template&id=6f6c933c&scoped=true&"
import script from "./DriverTicketDetail.vue?vue&type=script&lang=js&"
export * from "./DriverTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketDetail.vue?vue&type=style&index=0&id=6f6c933c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c933c",
  null
  
)

export default component.exports